import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
	XSpace,
	XDropdown,
	XAvatar,
	XDownOutlined,
	XSpaceNotif,
	Breadcrumb,
	XBreadcrumb,
	XUpdateModal,
	XHeaderContainer,
	HeaderTitle,
	XThemeDateDays,
	XBadge,
	XThem2Search,
	XDateTime,
} from './HeaderStyle';
import { XContainer, XThemeNotifications } from '../../styles/GlobalThemeStyle';
// actions
import { logoutApi, logoutReset } from '../../actions/logoutAction';
import {
	Col,
	Row,
	Space,
	notification,
	Avatar,
	Spin,
	Skeleton,
	Button,
} from 'antd';
import config from '../../config';
import {
	checkModulePermissions,
	getFirstAvailableRoute,
	getUserProfile,
} from '../../utils/helper';
import {
	AudioOutlined,
	SearchOutlined,
	SoundOutlined,
	UserOutlined,
} from '@ant-design/icons';
// Todo Notification Commented for Demo Branch
import NotificationPopover from '../Notification/NotificationsPopover';
import moment from 'moment';
import {
	getCodeUpdateDatesApi,
	getCodeUpdateDatesReset,
} from '../../actions/getCodeUpdateDatesAction';
import { Popover } from '@mui/material';

const HeaderFile = (props) => {
	const {
		logout,
		logoutReset,
		logoutState,
		getCodeUpdateDates,
		getCodeUpdateDatesState,
		getCodeUpdateDatesReset,
	} = props;
	const navigate = useNavigate();
	const [updatedDatesModal, setUpdatedDatesModal] = useState(false);
	const [datesLoading, setDatesLoading] = useState(false);
	const [updatedDates, setUpdatedDates] = useState('');
	const [open, setOpen] = useState(null);
	const organizationLogo = localStorage.getItem('org_logo');

	const items = [
		{
			key: '1',
			label: <Link to="/profile">My Profile</Link>,
			icon: (
				<img
					className="img-fluid"
					src="/images/profile-icon.svg"
					alt=""
				/>
			),
		},
		{
			type: 'divider',
		},
		localStorage.getItem('role') === 'super-admin' && {
			key: '2',
			label: (
				<Link
					onClick={() => {
						setUpdatedDatesModal(true);
						getCodeUpdateDates(); // Fetch the update dates when the link is clicked
					}}
				>
					Policies and Codes Updated at
				</Link>
			),
			icon: <SoundOutlined style={{ fontSize: '1rem' }} />,
		},
		localStorage.getItem('role') === 'super-admin' && { type: 'divider' }, // Optional divider
		{
			key: '3',
			label: <Link to="/change-password">Reset Password</Link>,
			icon: <img className="img-fluid" src="/images/reset.svg" alt="" />,
		},
		{
			type: 'divider',
		},
		{
			key: '4',
			label: (
				<Link
					onClick={() => {
						console.log('loks');
						logout();
					}}
				>
					Log Out
				</Link>
			),
			icon: <img className="img-fluid" src="/images/logout.svg" alt="" />,
		},
	];

	const formatDate = (date) => {
		const options = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};
		return date.toLocaleDateString('en-US', options);
	};
	const today = new Date();
	// use effect
	useEffect(() => {
		if (logoutState.apiState === 'success') {
			localStorage.removeItem('accessToken');
			localStorage.removeItem('username');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('expiresAt');
			localStorage.removeItem('profile');
			localStorage.removeItem('permissions');
			localStorage.removeItem('fcmToken');
			localStorage.removeItem('unlock_llm_configuration_tab');
			logoutReset();
			navigate('/login');
		} else if (logoutState.apiState === 'error') {
			notification.error({ message: logoutState.message });
			logoutReset();
		}
	}, [logoutState]);

	useEffect(() => {
		if (getCodeUpdateDatesState.apiState === 'loading') {
			setDatesLoading(true);
		}
		if (getCodeUpdateDatesState.apiState === 'success') {
			setDatesLoading(false);
			setUpdatedDates(getCodeUpdateDatesState.data);
		}
		if (getCodeUpdateDatesState.apiState === 'error') {
			setDatesLoading(false);
			notification.error({ message: getCodeUpdateDatesState.message });
		}
		getCodeUpdateDatesReset();
	}, [getCodeUpdateDatesState]);

	const handleOpen = (event) => {
		setOpen(event.currentTarget);
	};
	const handleClose = () => {
		setOpen(null);
	};
	const weekday = today.toLocaleDateString('en-US', { weekday: 'long' });
	const day = today.toLocaleDateString('en-US', { day: '2-digit' });
	const month = today.toLocaleDateString('en-US', { month: 'long' });
	const year = today.getFullYear();
	return (
		<>
			<XHeaderContainer fluid>
				<Row className="align-items-center" gutter={[15, 15]}>
					<Col sm={8}>
						<Link
							to={
								checkModulePermissions('dashboard')
									.authorized ||
								checkModulePermissions('nano-dashboard')
									.authorized
									? '/'
									: getFirstAvailableRoute()?.path || '/'
							}
						>
							<span className="logo">
								<img
									style={{ height: 30 }}
									src={'/images/reclaim_short_logo.svg'}
									alt="logo"
								/>
							</span>
						</Link>
					</Col>
					<Col sm={8} className="text-center">
						{/* <XThem2Search
							size="middle"
							placeholder="Search cases, patients, payers..."
							prefix={<SearchOutlined />}
							suffix={
								<Button
									type="text"
									icon={
										<img
											src="/images/search-mic.svg"
											alt="mic"
										/>
									}
								/>
							}
						/> */}
					</Col>
					<Col sm={8} className="text-end">
						<XDateTime>
							{weekday}, {day} {month}, {year}
						</XDateTime>
						<XBadge count={0}>
							<img
								onClick={handleOpen}
								src="/images/Badge.svg"
								alt="Badge"
							/>
						</XBadge>
						<Popover
							open={Boolean(open)}
							anchorEl={open}
							onClose={handleClose}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'right',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'center',
							}}
							PaperProps={{
								sx: {
									mt: 1,
									ml: 0.75,
									width: 360,
									p: '0 !important',
								},
							}}
						>
							<XThemeNotifications className="p-5 text-center">
								<p>Coming Soon</p>
							</XThemeNotifications>
						</Popover>
						{/* // Todo Notification Commented for Demo branch */}
						<NotificationPopover />
						<XDropdown
							menu={{
								items,
							}}
							// placement="bottom"
						>
							<XSpace>
								<XAvatar
									size={30}
									src={
										getUserProfile() === 'undefined'
											? '/images/prifile.svg'
											: `${
													config.s3_url
											  }${getUserProfile()}`
									}
								/>
								<XDownOutlined />
							</XSpace>
						</XDropdown>
					</Col>
				</Row>
			</XHeaderContainer>

			<XUpdateModal
				title="Policies and Codes Updated at"
				centered
				open={updatedDatesModal}
				onCancel={() => {
					setUpdatedDatesModal(false);
					getCodeUpdateDatesReset(); // Reset the state when modal is closed
					setUpdatedDates('');
				}}
				width={650}
				footer={false}
			>
				<Row gutter={(15, 15)}>
					{datesLoading && (
						<Col span={24} style={{ textAlign: 'center' }}>
							<Skeleton active paragraph={{ rows: 3 }} />
						</Col>
					)}
					{updatedDates &&
						updatedDates.map((item) => (
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								className="my-2"
								key={item._id}
							>
								<div className="modalCard">
									<Row
										gutter={(15, 15)}
										className="align-items-center"
									>
										<Col xs={6}>
											<div className="cardImgBg">
												<img
													src="/images/policies-ncd-icon.svg"
													alt=""
												/>
											</div>
										</Col>
										<Col xs={18}>
											<h4
												style={{
													color: '#212226',
													fontWeight: '600',
												}}
											>
												{item.code_type}
											</h4>
											<h6>
												{(item.code_type === 'ICD' &&
													item.update_name) ||
												(item.code_type === 'CPT' &&
													item.update_name) ? (
													<>
														Version -{' '}
														{item.update_name}
													</>
												) : (
													<>
														Released On -{' '}
														{moment(
															item.latest_update
																.date,
														).format('DD MMM YYYY')}
													</>
												)}
											</h6>
											<h6 style={{ fontStyle: '' }}>
												Last Checked Date -{' '}
												{moment(item.updatedAt).format(
													'DD MMM YYYY',
												)}
											</h6>
										</Col>
									</Row>
								</div>
							</Col>
						))}
				</Row>
			</XUpdateModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	logoutState: state.logout,
	getCodeUpdateDatesState: state.getCodeUpdateDates,
});

const mapDispatchToProps = (dispatch) => ({
	logout: (params) => dispatch(logoutApi(params)),
	logoutReset: () => dispatch(logoutReset()),
	getCodeUpdateDates: () => dispatch(getCodeUpdateDatesApi()),
	getCodeUpdateDatesReset: () => dispatch(getCodeUpdateDatesReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderFile);
